<template>
    <div style="height:100%">
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">系统管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">项目管理</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                <a-button @click="addkf" type="primary">添加角色</a-button>
                <a-button type="danger" :disabled="disabled" @click="delusers">删除角色</a-button>
            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    :placeholder="tstext"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list" >
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}" rowKey="gpid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <span slot="action" slot-scope="text,record" class="operate">
                        <!-- <a href="javascript:;" @click="toedit(record.id)" style="margin-right:12px"><a-icon type="edit" /> 跟进</a> -->
                        <a href="javascript:;" @click="edituser(record.gpid)"><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;" @click="deluser(record.gpid)"><a-icon type="delete" /> 删除</a>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>


                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 添加角色 -->
        <a-modal
        title="添加角色"
        :visible="addvisible"
        cancelText="取消"
        okText="确认"
        @ok="addhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="角色名称">
                    <a-input v-model="title"  v-decorator="['角色名称', { rules: [{ required: true, message: '请输入角色名称' }] }]"/>
                </a-form-item>
                <a-form-item label="坐席/微信客服">
                    <a-radio-group name="radioGroup" v-model="iskf" @change="onisChange">
                        <a-radio :value="2">
                        微信客服
                        </a-radio>
                        <a-radio :value="1">
                        坐席
                        </a-radio>
                        <a-radio :value="0">
                        否
                        </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="角色权限">
                    <a-tree
                        checkable
                        checkStrictly
                        v-model="checkedKeys"
                        :tree-data="menulist"
                        :replace-fields="replaceFields"
                        @expand="onExpand"
                        @select="onSelect"
                        @check="onCheck"
                    /> 
                </a-form-item>

                
            </a-form>
        </a-modal>

        <!-- 编辑角色 -->
        <a-modal
        title="编辑角色"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="edithandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">

                <a-form-item label="角色名称">
                    <a-input v-model="editinfo.title"   />
                </a-form-item>
                <a-form-item label="坐席/微信客服">
                    <a-radio-group name="radioGroup" v-model="editinfo.iskf" @change="oneditisChange">
                        <a-radio :value="2">
                        微信客服
                        </a-radio>
                        <a-radio :value="1">
                        坐席
                        </a-radio>
                        <a-radio :value="0">
                        否
                        </a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="角色权限">
                    <!-- {{editinfo.rules}} -->
                    <a-tree
                        checkStrictly
                        v-model="editinfo.rules"
                        checkable
                        :tree-data="menulist"
                        :replace-fields="replaceFields"
                        @check="oneditCheck"
                    /> 
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import { Modal } from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'gpid',key: 'gpid'},
    {title: '角色名称',dataIndex: 'title',key: 'title'},
    {title: '添加时间',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' }},
    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' }},
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            columns,
            data:[],
            tablespinning:true,
            pageSizeOptions:['10','20','30','40','100','200'],
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            addvisible:false,
            editvisible:false,
            tstext:"项目",

            searchtext:"",
            form: this.$form.createForm(this, { name: 'coordinated' }),
            username:"",

            indeterminate: true,
            checkAll: false,

            menulist:"",

            disabled:true,
            delids:[],
            tablex:"100%",

            title:"",
            iskf:0,

            replaceFields:{key:'id'},
            autoExpandParent: true,
            checkedKeys:[],
            selectedKeys:[],
            editid:"",
            editinfo:{rules:'',title:"",iskf:""},
            selectededitKeys:[]
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },
    mounted(){
        this.fetch()
        this.getmenu()
        this.tablespinning=false
        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };
    },
    methods:{
        
        // 权限
        onExpand(expandedKeys) {
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        onCheck(checkedKeys) {
            this.checkedKeys = checkedKeys.checked;
        },
        onSelect(selectedKeys, info) {
            this.selectedKeys = selectedKeys;
        },



        onChange(){

        },
        getmenu(){
            this.$axios.post('/api/system/rulelist',{
                // pagesize: this.size,
                // page:this.currentpage,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.menulist=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        fetch(){
            this.$axios.post('/api/system/grouplist',{
                pagesize: this.size,
                page:this.currentpage,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.pagination = pagination;
                    this.data=res.data.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        // 搜索
        onSearch(){

        },
        
        // 删除
        onSelectChange(selectedRowKeys){
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.delids=selectedRowKeys
            // console.log('selectedRowKeys changed: ', selectedRowKeys);
        },
        delusers(){
            var id=this.delids.join(",")
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        deluser(id){
            
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(id)
                },
                onCancel() {

                },
            });
        },
        handok(id){
            this.$axios.post('/api/system/delgroup',{
                gpids:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.disabled=true
                    this.$message.success('删除成功');
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },
        // 编辑角色
        edituser(id){
            this.editid=id
            this.$axios.post('/api/system/grouppage',{
                gpid: id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=true
                    var arr = res.data.data.rules.split(',');
                    this.editinfo=res.data.data
                    for (var i in arr){
                        arr[i]=parseInt(arr[i])
                    }
                    console.log(arr)
                    this.editinfo.rules=arr
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        oneditisChange(e){
            this.editinfo.iskf=e.target.value
        },
        oneditCheck(checkedKeys){
            this.editinfo.rules=checkedKeys.checked
            // console.log(checkedKeys.checked)
            // console.log(this.editinfo.rules)
        },

        edithandleOk(){
            // console.log(this.editinfo.rules)
            var rules=this.editinfo.rules.join(",")
            this.$axios.post('/api/system/editgroup',{
                gpid:this.editid,
                title: this.editinfo.title,
                iskf:this.editinfo.iskf,
                rules:rules
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 添加角色
        addkf(){
          this.addvisible=true

        },
        onisChange(e){
            this.iskf=e.target.value
        },
        addhandleOk(){
            var rules=this.checkedKeys.join(",")
            this.$axios.post('/api/system/addgroup',{
                title: this.title,
                iskf:this.iskf,
                rules:rules
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.addvisible=false
                    this.$message.success(res.data.msg); 
                    this.fetch()
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        handleCancel(){
            this.addvisible=false
            this.editvisible=false
        },
        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        // fetch(params = {}){
        //     this.$axios.post('/api/kefu/customerservicelist',{
        //         pagesize: this.size,
        //         page:this.currentpage,
        //         sources:this.sources,
        //     },{
        //         headers: {
        //             "token":localStorage.getItem('token'),
        //         }
        //     }).then((res)=>{
        //         if(res.data.code==200){
        //             this.tablespinning=false
        //             const pagination = { ...this.pagination };
        //             pagination.total = res.data.data.total;
        //             pagination.pageSize=this.size
        //             this.data=res.data.data.data
        //             this.pagination = pagination;
        //             this.totalpage=Math.ceil(res.data.data.total/this.size)
        //         }else{
        //             this.$message.warning(res.data.msg); 
        //         }
               
        //     })
        // },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/system/rolelist.vue